import script from "./PublicMoldesView.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicMoldesView.vue?vue&type=script&setup=true&lang=js"

import "./PublicMoldesView.vue?vue&type=style&index=0&id=336b2401&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-336b2401"]])

export default __exports__